export const T = {
  en_GB: {
    disabled: "Sustainability is disabled for this collection.",
    enableInSettings: "Enable it in Settings.",
  },
  nb_NO: {
    disabled: "Bærekraft er deaktivert for denne samlingen.",
    enableInSettings: "Aktiver det i Innstillinger.",
  },
} as const;
